module.exports = __webpack_public_path__ + "img/testResultsBanner.37d72bbf.png";